// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionOutlinedSvg from "@fishx/icons-svg/es/asn/InteractionOutlined";
import FishxIcon from '../components/FishxIcon';

var InteractionOutlined = function InteractionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionOutlinedSvg
  }));
};

InteractionOutlined.displayName = 'InteractionOutlined';
export default React.forwardRef(InteractionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InteractionOutlined.js
// module id = 2998
// module chunks = 0